import React from 'react'
import Counter from './Counter'

const LivestreamRow = ({ livestream, handleClick }) => {

  return (
    <div className='tr hover' onClick={handleClick}>
      <div className='td'>
        <p style={{ fontSize: '12px' }}>
          <span style={{ color: 'red' }}>((</span> ON AIR <span style={{ color: 'red' }}>))</span>
        </p>
      </div>
      <div className='td'>
        <p>
          { livestream.title }
        </p>
      </div>
      <div className='td'>
        <Counter seconds_since_start={livestream.seconds_since_start}/>
      </div>
    </div>
  )
}

export default LivestreamRow